class ExchangeValidator {
  constructor() {
    this.checkboxes = document.querySelectorAll('.jsExchangeCheckboxes');
    this.newProductHiddenInputs = document.querySelectorAll('.jsExchangeProductId');
    this.crmTagInputs = document.querySelectorAll('.jsExchangeCrmTags');
    this.init();
  }

  init() {
    this.bindEvents();

    this.setupCheckboxValidations();
    this.setupCrmTagValidations();
  }

  bindEvents() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.setupCheckboxValidations();
        this.setupCrmTagValidations();
      });
    });

    this.newProductHiddenInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.setupCheckboxValidations();
      });
    });

    this.crmTagInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.setupCrmTagValidations();
        this.setupCheckboxValidations();
      });
    });
  }

  setupCrmTagValidations() {
    this.checkboxes.forEach((checkbox) => {
      var crmInput = document.querySelector(`.jsExchangeOli${checkbox.dataset.oliId}CrmTag`);
      var noteInput = document.querySelector(`.jsExchangeOli${checkbox.dataset.oliId}Note`);

      ExchangeValidator.setCrmRequired(checkbox, crmInput);
      ExchangeValidator.setNoteRequired(checkbox, crmInput, noteInput);
    });
  }

  static setCrmRequired(checkbox, crmInput) {
    var input = crmInput;
    if (checkbox.checked) {
      input.required = true;
    } else {
      input.required = false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  static setNoteRequired(checkbox, crmInput, noteInput) {
    var input = noteInput;
    if (checkbox.checked && crmInput.value === 'other') {
      input.required = true;
    } else {
      input.required = false;
    }
  }

  setupCheckboxValidations() {
    this.clearCheckboxValidations();
    this.noCheckboxSelectedValidation();
    this.productChangedValidation();
  }

  clearCheckboxValidations() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.setCustomValidity('');
    });
  }

  noCheckboxSelectedValidation() {
    if ([...this.checkboxes].every(e => !e.checked)) {
      this.checkboxes[0].setCustomValidity('At least one item must be selected to be exchanged.');
    }
  }

  productChangedValidation() {
    this.newProductHiddenInputs.forEach((input) => {
      var checkboxSelector = `.jsExchangeOli${input.dataset.oliId}Checkboxes`
      var exchangeReasonSelector = `.jsExchangeOli${input.dataset.oliId}CrmTag`
      var checkbox = document.querySelector(checkboxSelector)
      var exchangeReason = document.querySelector(exchangeReasonSelector)

      if (checkbox.checked && !['other', ''].includes(exchangeReason.value)) {
        if (input.value === input.dataset.originalProductId) {
          checkbox.setCustomValidity('You must select a product that is different');
        }
      }
    });
  }
}

export default ExchangeValidator;
